<div #headerContainer class="plantlife-one-column-empty-header"></div>
